import { Formik, Form } from 'formik';
import { Button } from '@neshane/blueberry';
import { FormikInput } from '../../../../common/forms';
import { otpSchema } from '../../../../common/validation';

/**
 * OTP Step Component
 * Second step of user login - verify OTP code
 */
function OTPStep({ onSubmit, onBack, phoneNumber, loading = false, error = null }) {
    return (
        <Formik
            initialValues={{ code: '' }}
            validationSchema={otpSchema}
            onSubmit={onSubmit}
        >
            {({ isSubmitting, isValid }) => (
                <Form>
                    <FormikInput
                        name="code"
                        type="text"
                        label="کد تایید"
                        placeholder="123456"
                        helpText={`کد ارسال شده به شماره ${phoneNumber} را وارد کنید`}
                        maxLength={6}
                        disabled={loading || isSubmitting}
                        required
                        autoFocus tooltip="کد تایید - 123456" />

                    <Button
                        type="submit"
                        variant="primaryBrand"
                        text={loading || isSubmitting ? 'در حال تایید...' : 'تایید و ادامه'}
                        isLoading={loading || isSubmitting}
                        disabled={loading || isSubmitting || !isValid}
                        fit="parent"
                    />

                    <Button
                        type="button"
                        variant="secondaryNeutral"
                        text="تغییر شماره موبایل"
                        onClick={onBack}
                        disabled={loading || isSubmitting}
                        fit="parent"
                    />
                </Form>
            )}
        </Formik>
    );
}

export default OTPStep;
